// extracted by mini-css-extract-plugin
export default {"link":"AD-z","disabled":"BD-z"};